import { App } from 'vue'
import { logger } from '@/instance'

const modifyOpacity = (el: HTMLElement, flag: boolean) => {
  el.style.opacity = flag ? '1' : '0'
  el.style.pointerEvents = flag ? 'initial' : 'none'
}
export default {
  install(app: App, opt: any) {
    app.directive('opacity', {
      /**
       *
       * 用opacity来替换v-show达到动画效果
       * @param {*} el
       * @param {*} binding
       */
      mounted(el: any, binding) {
        if (!binding.value) {
          // 避免初次进入闪烁
          el.style.display = 'none'
        }
        logger.log('plugins/opacity', 'opacity mounted', arguments)
        binding.value !== binding.oldValue && modifyOpacity(el, binding.value)
        el.style.transition = 'opacity .15s ease-in-out'
      },
      updated(el: any, binding) {
        binding.value !== binding.oldValue && modifyOpacity(el, binding.value)
        el.style.display = ''
      },
      beforeUnmount(el: any) {
        logger.log('plugins/opacity', 'opacity before unmounted', arguments)
      },
    })
  },
}
